import { Route } from '@angular/router';
import { mgsAuthenticatedGuard } from '../mgs-guards';
import { USER_PATH } from '../mgs-path-defs';

export const userRoute: Route = {
  path: USER_PATH,
  resolve: {},
  canActivate: [mgsAuthenticatedGuard],
  loadComponent: () => import('./user.component')
};
